export const worldMapElementId = 'viking-world-map';
export const itineraryMapElementId = 'viking-itinerary-map';

export function getRootElement() {
  return /** @type {HTMLElement} */ (
    document.getElementById(itineraryMapElementId) ??
      document.getElementById(worldMapElementId) ??
      document.getElementById('root')
  );
}
